import Button from "../../Components/Button/Button";
import css from "./AddTaskModal.module.css";
import SvgOptions from "../../Components/Svg/SvgOptions";
import Svg from "../../Components/Svg/Svg";
import { useState, useEffect } from "react";
import Expandable from "../../Components/Expandable/Expandable";
import Form from "../../Components/Form/Form";
import FormType from "../../Components/Form/FormType";
import Utils from "../../Services/Utills";
import { Post, Get } from "../../Services/Server";
import Url from "../../Services/Url";
import User from "../../Services/User";
import { toast } from "react-toastify";

const AddMailCopy = ({ children, onNext, onBack, task, onClose }) => {
	const initialRecipients = (task?.taskMailCopies || []).map((mail, idx) => ({
		index: idx,
		name: mail.name,
		email: mail.email,
	}));

	const [recipients, setRecipients] = useState(initialRecipients);
	const [count, setCount] = useState(initialRecipients.length);
	const [expand, setExpand] = useState(true);

	const companyId = children?.AddTaskModal?.company?.id;

	useEffect(() => {
		children.AddMailCopyModal = recipients;
	}, [recipients]);

	useEffect(() => {
		if (companyId) {
			Get(Url.contact(companyId, "e"))
				.then((res) => {
					if (Array.isArray(res)) {
						const companyRecipients = res.map((contact, idx) => ({
							index: idx,
							name: contact.name,
							email: contact.email,
						}));
						setRecipients((prev) => [...prev, ...companyRecipients]);
						setCount((prev) => prev + companyRecipients.length);
					}
				})
				.catch((err) => {
					console.error("Failed to fetch contacts:", err);
					toast("Could not fetch contacts for this company");
				});
		}
	}, [companyId]);

	const onSubmit = (e) => {
		const dt = Utils.FormObject(e);
		setRecipients((prev) => [...prev, { index: count, ...dt }]);
		setCount(count + 1);
		setExpand(false);
	};

	const handleDelete = (recipientToDelete) => {
		setRecipients((prev) =>
			prev.filter((r) => r.index !== recipientToDelete.index)
		);
	};

	const handleNext = () => {
		if (task) {
			
			const fullTask = {
				...task, 
				id: task.id,
				vessel: children.AddTaskModal?.vessel || task.vessel,
				location: children.AddTaskModal?.location || task.location,
				serviceOrder: children.AddTaskModal?.serviceOrder || task.serviceOrder,
				taskOptions: children.AddTaskModal?.taskOptions || task.taskOptions,
				deliveryEstimate:
					children.AddTaskModal?.deliveryEstimate || task.deliveryEstimate,

				taskOperations: task.taskOperations || [
					{ owner: true, operation: { id: User.getBiodata().id } },
				],

				taskEquipmentList:
					children.AddEquipmentModal?.map((v) => ({
						name: v.equipment.equipment,
						type: v.equipment.type,
						taskMilestones: v.equipment.template.milestones.map((m) => ({
							...m,
							status: { id: 1 },
							id: undefined,
						})),
					})) ||
					task.taskEquipmentList ||
					[],

				// This modal updates mail copies
				taskMailCopies: recipients.map(({ name, email }) => ({ name, email })),
			};

			Post(Url.saveTask, fullTask)
				.then(() => {
					toast("Task updated");
				})
				.catch(() => {
					toast("Error updating task");
				})
				.finally(() => {
					// setSaving(false);
					onClose && onClose(fullTask);
				});
		} else {
			onNext && onNext(recipients); // Normal next for create flow
		}
	};

	const handleBack = () => {
		onBack && onBack();
	};

	const fmoption = {
		Fields: [
			{ name: "name", label: "Name", element: FormType.Input },
			{ name: "email", label: "Email", element: FormType.Input },
		],
		Buttons: [{ text: "Save", className: "Btn-Mid Active" }],
	};

	return (
		<div className={css.Cont}>
			<div className={css.Head}>
				<h2>Add Mail Recipients</h2>
				<Button
					onClick={() => setExpand(!expand)}
					className="Btn-Mid Active"
					icon={SvgOptions.Add}
				/>
			</div>

			<div>
				<Expandable expand={expand} height={240}>
					<div style={{ margin: "10px" }}>
						<Form onSubmit={onSubmit}>{fmoption}</Form>
					</div>
				</Expandable>
			</div>

			<div className={css.Body}>
				<div className={css.Engineers}>
					{recipients.map((r) => (
						<RecipientView onDelete={handleDelete} key={r.index}>
							{r}
						</RecipientView>
					))}
				</div>
				<div className={css.Controls}>
					<div>
						<Button onClick={handleBack} className="Btn-Mid Inverse">
							Back
						</Button>
					</div>
					<div>
						<Button onClick={handleNext} className="Btn-Mid Active">
							Save
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};

const RecipientView = ({ children, onDelete }) => {
	const { name, email } = children;
	const handleDelete = () => {
		onDelete && onDelete(children);
	};
	return (
		<div className={css.EquipmentView}>
			<div>
				<div>{name}</div>
				<div onClick={handleDelete} className={css.DeleteIcon}>
					<Svg>{SvgOptions.Delete}</Svg>
				</div>
			</div>
			<div>{email}</div>
		</div>
	);
};

export default AddMailCopy;
